import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { BASE_IMAGES_URL, ACCESS_FILES_API_KEY } from "Constants";

class TableContentTopSearch extends Component {
  // Create table body
  renderSessionQnqinsightsTablelist() {
    return (
      <tr>
        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12 d-flex">
              <div className="analytics-table-td">-</div>
            </div>
          </div>
        </td>
        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div align="center">-</div>
            </div>
          </div>
        </td>
        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div align="center">-</div>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  // Printing the output

  render() {
    return (
      <div className="social-content">
        <div className="tableHeaderSection">
          <h5>Most Search keywords</h5>
          <h6>(Most Search keywords related to sessions)</h6>
        </div>
        <table className="table">
          <thead className="analyticsTable">
            <tr>
              <th>Keyword</th>
              <th>Number of time search</th>
              <th>Number of hits</th>
            </tr>
          </thead>
          <tbody className="tbody-background">
            {this.renderSessionQnqinsightsTablelist()}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    dashboardMostsearchKeysTablelist: state.dashboardMostsearchKeysTablelist,
  };
}

export default connect(mapStateToProps)(TableContentTopSearch);
